// modifer: styles/jss/nextjs-material-kit-pro/pages/sectionsSections/featuresStyle
import { section, container, title } from 'styles/jss/original/base';

const styles = {
  section,
  container,
  title: {
    ...title,
    textAlign: 'center'
  },
  textCenter: {
    textAlign: 'center'
  },
  infoArea: {
    '@media (max-width: 576px)': {
      padding: '20px 0'
    }
  }
};

export default styles;
